export var LoggersCalibrationExpirationOptions;
(function (LoggersCalibrationExpirationOptions) {
    LoggersCalibrationExpirationOptions[LoggersCalibrationExpirationOptions["ONEYEAR"] = 1] = "ONEYEAR";
    LoggersCalibrationExpirationOptions[LoggersCalibrationExpirationOptions["TWOYEARS"] = 2] = "TWOYEARS";
    LoggersCalibrationExpirationOptions[LoggersCalibrationExpirationOptions["THREEYEARS"] = 3] = "THREEYEARS";
    LoggersCalibrationExpirationOptions[LoggersCalibrationExpirationOptions["FOURYEARS"] = 4] = "FOURYEARS";
    LoggersCalibrationExpirationOptions[LoggersCalibrationExpirationOptions["FIVEYEARS"] = 5] = "FIVEYEARS";
})(LoggersCalibrationExpirationOptions || (LoggersCalibrationExpirationOptions = {}));
export const EXP_OPTIONS = Object.values(LoggersCalibrationExpirationOptions).filter((value) => typeof value !== 'string');
